import React from 'react';

/**
 * Specifies whether the account is in a read-only mode or not.
 */
export const IsAccountReadOnly = React.createContext(undefined);
